import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpContextToken,
  HttpContext,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { AuthService } from './auth.service';

const CHECK_TOKEN = new HttpContextToken<boolean>(() => false);

export function checkToken() {
  return new HttpContext().set(CHECK_TOKEN, true);
}

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  private adminToken: string | null;
  private adminUserToken: string | null;

  constructor(private authService: AuthService) {
    this.adminToken = localStorage.getItem('token');
    this.adminUserToken = localStorage.getItem('refrehsToken');
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.context.get(CHECK_TOKEN)) {
      const isValidToken = this.authService.isValidToken();

      if (isValidToken) {
        return this.addToken(req, next);
      } else {
        return this.updateAccesTokenAndRefreshToken(req, next);
      }
    }
    return next.handle(req);
  }

  private addToken(request: HttpRequest<unknown>, next: HttpHandler) {
    const token = localStorage.getItem('token');
    if (token) {
      const authReq = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`),
      });
      return next.handle(authReq);
    }
    return next.handle(request);
  }

  private updateAccesTokenAndRefreshToken(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ) {
    const refrehsToken = this.adminUserToken;
    const isValidRefreshToken = this.authService.isValidRefreshToken();
    if (refrehsToken && isValidRefreshToken) {
      return this.authService
        .sendRefreshToken(refrehsToken)
        .pipe(switchMap(() => this.addToken(req, next)));
    }

    return next.handle(req);
  }
}
